<template>
  <div class="otn-step-two">
    <v-simple-table class="mb-12">
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-center">
            Position
          </th>
          <th class="text-center">
            Sangle taille (mm)
          </th>
          <th class="text-center">
            Sangle matière
          </th>
          <th class="text-center">
            Velcro
          </th>
          <th class="text-center">
            Clip
          </th>
          <th class="text-center">
            Coussin
          </th>
          <th class="text-center">
            Atelier (mm)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Epaulière</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.shoulder_pad_position"
                :items="dropdowns.shoulder_pad_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.shoulder_pad_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Epaulière) Sangle"
              :class="{ error: errors.has('(Epaulière) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.shoulder_pad_strap_matter"
              :items="dropdowns.shoulder_pad_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.shoulder_pad_velcro"
              :items="dropdowns.shoulder_pad_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.shoulder_pad_clip"
                :items="dropdowns.shoulder_pad_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.shoulder_pad_cushion"
                :items="dropdowns.shoulder_pad_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.shoulder_pad_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Epaulière) Atelier"
              :class="{ error: errors.has('(Epaulière) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Thorax</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.thorax_position"
                :items="dropdowns.thorax_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.thorax_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Thorax) Sangle"
              :class="{ error: errors.has('(Thorax) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.thorax_strap_matter"
              :items="dropdowns.thorax_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.thorax_velcro"
              :items="dropdowns.thorax_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.thorax_clip"
                :items="dropdowns.thorax_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.thorax_cushion"
                :items="dropdowns.thorax_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.thorax_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Thorax) Atelier"
              :class="{ error: errors.has('(Thorax) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Plastron</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.chest_position"
                :items="dropdowns.chest_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.chest_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Sangle"
              :class="{ error: errors.has('(Plastron) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.chest_strap_matter"
              :items="dropdowns.chest_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.chest_velcro"
              :items="dropdowns.chest_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.chest_clip"
                :items="dropdowns.chest_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.chest_cushion"
                :items="dropdowns.chest_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.chest_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Atelier"
              :class="{ error: errors.has('(Plastron) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Bassin</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.pelvis_position"
                :items="dropdowns.pelvis_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.pelvis_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Bassin) Sangle"
              :class="{ error: errors.has('(Bassin) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.pelvis_strap_matter"
              :items="dropdowns.pelvis_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.pelvis_velcro"
              :items="dropdowns.pelvis_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.pelvis_clip"
                :items="dropdowns.pelvis_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.pelvis_cushion"
                :items="dropdowns.pelvis_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.pelvis_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Bassin) Atelier"
              :class="{ error: errors.has('(Bassin) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Femorale</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.femoral_position"
                :items="dropdowns.femoral_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.femoral_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Femorale) Sangle"
              :class="{ error: errors.has('(Femorale) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.femoral_strap_matter"
              :items="dropdowns.femoral_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.femoral_velcro"
              :items="dropdowns.femoral_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.femoral_clip"
                :items="dropdowns.femoral_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.femoral_cushion"
                :items="dropdowns.femoral_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.femoral_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Femorale) Atelier"
              :class="{ error: errors.has('(Femorale) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Tibiale</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.tibial_position"
                :items="dropdowns.tibial_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.tibial_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tibiale) Sangle"
              :class="{ error: errors.has('(Tibiale) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.tibial_strap_matter"
              :items="dropdowns.tibial_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.tibial_velcro"
              :items="dropdowns.tibial_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.tibial_clip"
                :items="dropdowns.tibial_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.tibial_cushion"
                :items="dropdowns.tibial_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.tibial_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tibiale) Atelier"
              :class="{ error: errors.has('(Tibiale) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Pied</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.foot_position"
                :items="dropdowns.foot_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.foot_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Pied) Sangle"
              :class="{ error: errors.has('(Pied) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.foot_strap_matter"
              :items="dropdowns.foot_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.foot_velcro"
              :items="dropdowns.foot_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.foot_clip"
                :items="dropdowns.foot_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.foot_cushion"
                :items="dropdowns.foot_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>

          <td>
            <v-text-field
              v-model="form.foot_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Pied) Atelier"
              :class="{ error: errors.has('(Pied) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
        <tr>
          <th>Poignet</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.wrist_position"
                :items="dropdowns.wrist_position"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.wrist_size_trap"
              v-validate="'numeric|max:4'"
              data-vv-name="(Poignet) Sangle"
              :class="{ error: errors.has('(Poignet) Sangle') }"
              type="number"
              hide-details
              outlined
            />
          </td>
          <td>
            <v-select
              v-model="form.wrist_strap_matter"
              :items="dropdowns.wrist_strap_matter"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.wrist_velcro"
              :items="dropdowns.wrist_velcro"
              item-text="label"
              item-value="value"
              label
              outlined
              clearable
              hide-details
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.wrist_clip"
                :items="dropdowns.wrist_clip"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.wrist_cushion"
                :items="dropdowns.wrist_cushion"
                item-text="label"
                item-value="value"
                label
                outlined
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-model="form.wrist_workshop"
              v-validate="'numeric|max:4'"
              data-vv-name="(Poignet) Atelier"
              :class="{ error: errors.has('(Poignet) Atelier') }"
              type="number"
              hide-details
              outlined
            />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-layout
      justify-space-between
      wrap
    >
      <v-flex sm6>
        <h3>FINITION :</h3>

        <v-switch
          v-model="form.idc_anti_pressure_ulcers"
          hide-details
          class="mb-2"
          label="Mousse Anti Escarres"
        />
        <v-select
          v-model="form.foam_under_otn"
          :items="dropdowns.foam_under_otn"
          item-text="label"
          item-value="value"
          label="Mousse sous l’OTN :"
          filled
          clearable
          hide-details
          class="mb-4"
        />
        <v-text-field
          v-model="form.thickness"
          v-validate="'numeric|max:4'"
          data-vv-name="(Finition) Epaisseur"
          :class="{ error: errors.has('(Finition) Epaisseur') }"
          label="Epaisseur"
          type="number"
          outlined
          hide-details
        />
        <v-switch
          v-model="form.idc_coating"
          hide-details
          class="mb-2"
          label="Coating sous l’OTN"
        />
        <v-text-field
          v-model="form.reinforcement"
          label="Renfort :"
          hide-details
          maxlength="20"
          outlined
        />
      </v-flex>

      <v-flex sm6>
        <v-select
          v-model="form.matter"
          :items="dropdowns.matter"
          item-text="label"
          item-value="value"
          label="Matière :"
          filled
          clearable
          hide-details
          class="mb-3"
        />

        <h3 class="mb-4">
          Poignée de portage :
        </h3>
        <v-select
          v-model="form.type_handle"
          :items="dropdowns.type_handle"
          item-text="label"
          item-value="value"
          label="Aucune :"
          filled
          hide-details
          class="mb-4"
        />
        <v-text-field
          v-model="form.quantity"
          v-validate="'numeric|max:4'"
          data-vv-name="(Poignée de portage) Quantité"
          :class="{ error: errors.has('(Poignée de portage) Quantité') }"
          label="Quantité :"
          type="number"
          class="mb-4"
          outlined
          hide-details
        />
        <v-text-field
          v-model="form.location"
          label="Emplacement"
          maxlength="20"
          hide-details
          outlined
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OtnStepTwo",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getOtnOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style></style>
